import { ReactNode } from 'react';

import { cn } from '@natu/utils/cn';

import { type DecoratorWrapperVariant, decorators } from './decorators';

interface DecoratorWrapperProps {
  variant?: DecoratorWrapperVariant;
  children?: ReactNode;
  className?: string;
  component?: React.ElementType;
}

export const DecoratorWrapper = ({
  variant,
  children,
  className,
  component,
  ...rest
}: DecoratorWrapperProps) => {
  const Decorator = variant && decorators[variant];
  const Comp = component || 'div';

  return (
    <Comp className={cn(className, 'relative')} {...rest}>
      {children}
      {Decorator && <Decorator />}
    </Comp>
  );
};

export type { DecoratorWrapperVariant } from './decorators';
export { CareersDecorator } from './decorators/CareersDecorators';
